import { Reducer } from 'redux';
import { RecurrenceState, RecurrencesTypes } from './types';

const INITIAL_STATE: RecurrenceState = {
  data: [],
  hasError: false,
  isLoading: true,
  total: 0,
};

const reducer: Reducer<RecurrenceState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RecurrencesTypes.LOAD_RECURRENCES_REQUEST:
      return { ...state, isLoading: true };
    case RecurrencesTypes.LOAD_RECURRENCES_FAILURE:
      return { ...state, isLoading: false, hasError: true };
    case RecurrencesTypes.LOAD_RECURRENCES_SUCCESS:
      return {
        hasError: false,
        isLoading: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default reducer;
